import { WIDTH_CARD, GAP_CARD, MOBILE_LEFT_OFFSET_CAROUSEL } from "./constants";

export const generateDistances = (len: number, widthContainer: number) => {
  const leftOffsetToCenter = widthContainer / 2 - WIDTH_CARD / 2;
  return new Array(len)
    .fill(0)
    .map(
      (_, index) =>
        index * (WIDTH_CARD + GAP_CARD) -
        leftOffsetToCenter +
        (WIDTH_CARD + GAP_CARD) * 2,
    );
};

export const generateDistancesMobile = (
  len: number,
  widthContainer: number,
) => {
  if (!widthContainer) {
    return [];
  }
  const leftOffsetToCenter = widthContainer / 2 - WIDTH_CARD / 2;

  return new Array(len)
    .fill(0)
    .map(
      (_, index) =>
        index * (WIDTH_CARD + GAP_CARD) -
        leftOffsetToCenter +
        MOBILE_LEFT_OFFSET_CAROUSEL,
    );
};

export const findClosest = (arr, num) =>
  arr.reduce(
    (closest, n) => (Math.abs(n - num) > Math.abs(closest - num) ? closest : n),
    undefined,
  );
